import CameraController from "./camera_controller"
import RadiantMP from './rmp.min.mjs';

// Connects to data-controller="cctv--replay"
export default class extends CameraController {
  static targets = []
  static values = {
    cameraId: String, url: String, cameraName: String, type: String, playerKey: String, exportButton: String
  }

  connect() {
  }

  async reply() {
    let data = {}

    let camerasContainer = document.querySelector('#cameras_container');
    camerasContainer.innerHTML = ""

    document.dispatchEvent(new CustomEvent("archive:play", {
      bubbles: true, detail: {callback: (state) => data = state}
    }))

    const params = this.buildURLSearchParams(this.cameraIdValue, data.min, data.max)
    // const response = await fetch(`/cctv/cameras/footages/show?${params.toString()}`, {
    //   method: 'GET'
    //
    // });

    // let response_data = await response.json();
    //
    // if (response_data['status'] === 'ok') {

      this.urlValue = `${this.urlValue}?${params.toString()}`;
      await this.buildCameraBlock(camerasContainer)
    // } else {
    //   await this.buildCameraBlock(camerasContainer, response_data['message'])
    // }
  }


  async buildCameraBlock(camerasContainer, info = null) {
    this.container = document.createElement("div");
    this.containerBuild(this.container, this.cameraIdValue)

    let wrapper = document.createElement('div');
    this.playerElement = document.createElement("div");
    this.playerBuild(this.playerElement, this.cameraIdValue)

    this.infoElement = document.createElement("div");

    this.headerElement = document.createElement("div");
    this.headerBuild(this.headerElement, this.cameraNameValue)


    let export_block = document.createElement("div");
    let link = document.createElement("a");
    this.linkBuild(link)

    let data = {}
    document.dispatchEvent(new CustomEvent("archive:play", {
      bubbles: true, detail: {callback: (state) => data = state}
    }))


    const params = this.buildURLSearchParams(this.cameraIdValue, data['min'], data['max'])
    this.linkExportBuild(link, params)

    export_block.appendChild(link);
    this.headerElement.appendChild(export_block)

    this.container.appendChild(this.headerElement);
    this.container.appendChild(this.infoElement);
    this.container.appendChild(wrapper);

    wrapper.appendChild(this.playerElement);

    camerasContainer.appendChild(this.container);


    if (info) {
      this.playerElement.style.display = 'none'
      this.infoFill(this.infoElement, info)
    }

    this.player = new RadiantMP('player_' + this.cameraIdValue);
    await this.player.init(this.initRmp(this.urlValue));

  }


}
